/**
 * Place an element behind one or more elements on the screen, using ill advised absolute positioning.
 */
; window.verticalLineFromTo = (() => {

    const lineToFromElement = `
        <div data-linetofrom class="absolute z-1 flex flex-col items-center">
            <div class="h-4">
                <svg class="w-4 h-4 text-black" stroke-width="2" stroke="#073f83" fill="#fff" viewBox="0 0 20 20">
                    <circle cx="10" cy="10" r="8" />
                </svg>
            </div>
            <svg class="w-1 flex-1 -my-2 -z-1" viewBox="0 0 2 100" preserveAspectRatio="none">
                <line x1="1" y1="0" x2="1" y2="100" stroke="#073f83" stroke-width="1"/>
            </svg>
            <div class="h-4">
                <svg class="w-4 h-4 text-black" stroke-width="2" stroke="#073f83" fill="#fff" viewBox="0 0 20 20">
                    <circle cx="10" cy="10" r="8" />
                </svg>
            </div>
        </div>
    `

    document.addEventListener('DOMContentLoaded', function() {
        const fromElements = document.querySelectorAll(`[data-linefromkey]`)
        fromElements.forEach(function(e) {
            const key = e.getAttribute('data-linefromkey')
            createLine(key)
        })
    })

    const createLine = (key, options = {}) => {
        const fromElement = options.fromElement || document.querySelector(`[data-linefromkey="${key}"]`);
        const toElement = options.toElement || document.querySelector(`[data-linetokey="${key}"]`);

        if (!fromElement || !toElement) {
            return;
        }

        // The right margin
        const marginRight = options.marginRight || fromElement.getAttribute('data-linemarginright') || 0;

        console.log('margin right', marginRight);

        // Create the template
        const template = document.createElement('div');
        template.innerHTML = options.lineToFromElement || lineToFromElement;
        const lineElement = template.children[0];
        const parentElement = fromElement.parentElement;
        const parentStyle = window.getComputedStyle(parentElement);
        if (parentStyle.position !== 'relative') {
            return;
        }
        parentElement.appendChild(lineElement);

        // The height of the element should be:
        // The height of the parent element
        // Minus the distance from the top of the parent
        // Plus the distance from the bottom of the toElement to the bottom of the parent
        const parentRect = parentElement.getBoundingClientRect();
        const fromRect = fromElement.getBoundingClientRect();
        const toRect = toElement.getBoundingClientRect();
        const distanceBetweenParentAndFrom = fromRect.top - parentRect.top;
        const distanceBetweenParentAndTo = toRect.bottom - parentRect.bottom;

        // Finally, we want to align the first and last circle centers with the from and to elements
        // So we need to subtract half the height of the first and last element
        const fromElementHeight = fromRect.height;
        const toElementHeight = toRect.height;
        const lineElementFirstElementHeight = lineElement.children[0].offsetHeight;
        const lineElementLastElementHeight = lineElement.children[2].offsetHeight;
        const topOffset = (fromElementHeight / 2) - (lineElementFirstElementHeight / 2)
        const bottomOffset = (toElementHeight / 2) - (lineElementLastElementHeight / 2)
        const totalOffset = topOffset + bottomOffset;

        // Calculate the total diff
        const pixelDiff = -distanceBetweenParentAndFrom + distanceBetweenParentAndTo - totalOffset;

        lineElement.style.left = fromRect.left - parentRect.left - lineElement.offsetWidth - marginRight + 'px';
        lineElement.style.top = distanceBetweenParentAndFrom + topOffset + 'px';
        lineElement.style.height = 'calc('+ pixelDiff + 'px + 100%)';
    };

    return {
        createLine,
    }

})()
